'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function FacebookPixelTracker() {
  const pathname = usePathname();
  
  // This effect runs whenever the route changes
  useEffect(() => {
    // Only track if fbq is available (client-side)
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [pathname]); // Only depend on pathname to avoid Suspense requirement

  return null; // This component doesn't render anything
}

// Add TypeScript declaration for fbq
declare global {
  interface Window {
    fbq: any;
  }
}